export default __webpack_public_path__ + "static/media/transform-lifes-6-costa-rica.39caadc3.png";